module.exports = __webpack_public_path__ + "public/img/pd.a3c2df8b.png";